<template lang="pug">
  .row.invoice-with-actions
    .invoice-item-wrap.xs-12.md-7.lg-8
      transition-group(name="fade" tag="div").invoice-items
        slot(name="items")

    .cta-section.xs-12.md-5.lg-4
      .total
        slot(name="totals")

      .ctas
        slot(name="ctas")
  
</template>

<script>
  export default {
    name: "InvoiceWithActionsLayout"
  }
</script>

<style scoped lang="stylus">
  .invoice-with-actions
    .total
      span
        display inline-block

    .ctas
      padding-top 0.5em
      max-width 18em

      .mr-btn
        margin 1em 0

    @media mq-mobile
      .ctas
        margin auto
        max-width 25em

    @media mq-tablet
      .ctas
        margin auto
        max-width 25em

    @media mq-desktop-md-plus
      .invoice-items
      .cta-section
        padding 0em 1.5em

      .invoice-item-wrap
        display flex //* suposedly helps IE 11
        overflow-x auto
        border-right 2px solid #ccc

      .invoice-items
        display inline-flex

        .invoice-item
          display inline-block

      .total
        span
          display block

</style>
